import moment from 'moment';
import React, {useCallback} from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import { openExternalURL } from '../../../../../misc/openLinks';
import ButtonLink from '../../../../elements/ButtonLink';
import ExternalContentIcon from '../../../../elements/icons/ExternalContentIcon/ExternalContentIcon';
import styles from './JoinMeetingButton.module.scss';

const JoinMeetingButton = props => {
    const {eventId, type, url, start, end, className = '', style, children} = props,
        i18n = useI18n(),
        disabled = moment().isBefore(start) || moment().isAfter(end);

    const handleClick = useCallback((e) => {
        e.preventDefault();

        if (!disabled) {
            openExternalURL({url, target: 'iframe', eventId});
        }
    }, [url, disabled]);

    if (!url) return null;

    return (
        <ButtonLink className={[styles.JoinMeetingButton, className].join(' ')} href={disabled ? null : url} onClick={handleClick} disabled={disabled}>
            <div>
                <ExternalContentIcon session_content_type={type} style={{marginRight: 6}} disabled={disabled} />
                {children}
            </div>
        </ButtonLink>
    );
};

export default JoinMeetingButton;
